<template>
  <div class="container">
    <span>Clientes / Beneficiarios / Usuarios</span>
    <table class="table table-striped" style="border: 1px solid #000;">
      <thead>
        <tr>
          <th scope="col">Número</th>
          <th scope="col">Descripción</th>
          <th scope="col">Cantidad</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, items) in items" :key="items">
          <td>{{ items + 1 }}</td>
          <td>{{ item.nombre }}</td>
          <td>{{ formattedNumber(item.cantidad) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: ["contenido"],
  data() {
    return {
      encabezado: "Número",
      items: null,
      datosTable: null,
    };
  },

  methods: {
    formattedNumber: function(value) {
      return new Intl.NumberFormat("de-DE").format(value);
    },
  },

  mounted() {
    setTimeout(() => {
      const a = this.contenido.clientes;
      const unArray = Object.keys(this.contenido.clientes);
      this.items = unArray.map((i) => a[i]);
      //Seguda tabla
    }, 1000);
  },
};
</script>

<style scoped>
.container {
  margin-top: 20px;
}

th {
  text-align: center !important;
  font-size: 14px !important ;
}

td {
  text-align: left;
}
</style>
